// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchForm_form__g25IW","input":"SearchForm_input__HQg_c","removeButton":"SearchForm_removeButton__Nx7BJ"};